module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_pp3_5010.d0cb6b59.png";